import React from 'react';
import { Link } from 'react-router-dom';
import { ExclamationCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { PrimaryBtn } from '../Assets/Buttons';

const BacktestError = ({ error }) => {
    const status = error?.status;
    const sport = error?.sport || 'this sport';

    // 429 - User has reached max systems for sport
    if (status === 429) {
        return (
            <div className="flex items-center justify-center p-8">
                <div className="max-w-md w-full bg-white dark:bg-brand-dark-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-8">
                    <div className="flex flex-col items-center text-center space-y-6">
                        <div className="rounded-full bg-yellow-100 dark:bg-yellow-900/20 p-3">
                            <ExclamationCircleIcon className="h-12 w-12 text-yellow-600 dark:text-yellow-500" />
                        </div>
                        
                        <div className="space-y-2">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                System Limit Reached
                            </h3>
                            <p className="text-gray-600 dark:text-gray-400">
                                You've reached the maximum number of systems allowed for {sport} on your current plan.
                            </p>
                        </div>

                        <div className="w-full pt-2">
                            <Link to="/pricing">
                                <PrimaryBtn 
                                    text="View Pricing Plans"
                                    className="w-full"
                                />
                            </Link>
                        </div>

                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            Upgrade to increase your system limits and unlock more features.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    // Other errors - Generic error message
    return (
        <div className="flex items-center justify-center p-8">
            <div className="max-w-md w-full bg-white dark:bg-brand-dark-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-8">
                <div className="flex flex-col items-center text-center space-y-6">
                    <div className="rounded-full bg-red-100 dark:bg-red-900/20 p-3">
                        <ExclamationTriangleIcon className="h-12 w-12 text-red-600 dark:text-red-500" />
                    </div>
                    
                    <div className="space-y-2">
                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                            Something Went Wrong
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400">
                            We apologize for the inconvenience. An error occurred while processing your system.
                        </p>
                    </div>

                    <p className="text-sm text-gray-500 dark:text-gray-400">
                        Please try again later. If the problem persists, contact our support team.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BacktestError;